export enum MapInjectionKeys {
  map = 'vueMap:map',
  popup = 'vueMap:popup'
}